<img *ngIf="backgroundMedia"
     class="cms-block-background"
     src="{{backgroundMedia.url}}"
     alt="{{alt}}"
>